<div class="card-layout">
  <!-- Header always visible -->
  <div class="d-flex flex-row align-items-center psic-gap-4">
    <img
      src="../../../../assets/images/payment-info/payment-schedule.svg"
      alt="payment-schedule"
      class="card-image"
    />
    <div class="card-header">Payment Schedule</div>
    @if (isLoading()) {
    <app-card-loader></app-card-loader>
    }
  </div>

  @if (!isLoading() && !dcBillingFailed) {
  <div class="separator"></div>
  @if (paymentScheduleData(); as scheduleData) { @if (isMobile()) {
  <div class="d-flex flex-column psic-gap-6">
    <div class="d-flex flex-row align-items-center justify-content-between psic-gap-1">
      <p class="alt-bold">Number of Payments</p>
      <p class="alt">{{ scheduleData.Installments.PaymentFrequency }}</p>
    </div>
    <div class="d-flex flex-column psic-gap-6">
      @for (item of scheduleData.Installments.Installment; track item.DueDate) {
      <div class="d-flex flex-column psic-gap-2">
        <div class="d-flex flex-row justify-content-between align-items-center">
          <div class="caption">Due: {{ item.DueDate | date : 'MM/dd/yyyy' }}</div>
          <div class="d-flex flex-row align-items-center psic-gap-3">
            @if (item.GoToPay === '1') {
            <mat-icon [svgIcon]="'download'" class="p1-50-color psic-mr-3"></mat-icon>
            }
            <p class="alt-bold" [ngClass]="{ overDueDate: item.OverDue === '1' }">
              {{ formatAmount(item.Balance) }}
            </p>
          </div>
        </div>
        @if (item.GoToPay === '1') {
        <lib-tag
          [tagType]="'colorFill'"
          [tagText]="'Next payment'"
          [tagTheme]="'neutralBlue'"
        ></lib-tag>
        }
        <div class="separator"></div>
      </div>
      }
    </div>
  </div>
  } @else {
  <div class="d-flex flex-row justify-content-between psic-gap-1">
    <p class="alt-bold">Number of Payments</p>
    <p class="alt">{{ scheduleData.Installments.PaymentFrequency }}</p>
  </div>
  @for (item of scheduleData.Installments.Installment; track item.DueDate) {
  <div class="d-flex flex-column psic-gap-2">
    <div class="d-flex flex-row justify-content-between align-items-center">
      <div class="caption">Due: {{ item.DueDate | date : 'MM/dd/yyyy' }}</div>
      <div class="d-flex flex-row align-items-center psic-gap-3">
        @if (item.GoToPay === '1') {
        <div class="d-flex flex-row align-items-center" style="gap: 12px">
          <lib-tag
            [tagType]="'colorFill'"
            [tagText]="'Next payment'"
            [tagTheme]="'neutralBlue'"
          ></lib-tag>
          <mat-icon [svgIcon]="'download'" class="p1-50-color psic-mr-3"></mat-icon>
        </div>
        }
        <p class="alt-bold" [ngClass]="{ overDueDate: item.OverDue === '1' }">
          {{ formatAmount(item.Balance) }}
        </p>
      </div>
    </div>
    <div class="separator"></div>
  </div>
  } }
  <lib-alert
    alertText="These amounts don't include the transaction fees."
    [alertTheme]="'default'"
    [alertType]="'small'"
  ></lib-alert>
  } @else {
  <lib-alert
    alertText="No payment schedule available."
    [alertTheme]="'default'"
    [alertType]="'small'"
  ></lib-alert>
  } }
</div>
